module.exports = __webpack_public_path__ + "img/Group1551@2x.028fde4f.webp";